import { render } from "./NovoCliente.vue?vue&type=template&id=7e1a2294"
import script from "./NovoCliente.vue?vue&type=script&lang=js"
export * from "./NovoCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__